module.exports = __webpack_public_path__ + "img/keypoints_guide_sunblock_icon.258c6f00.png";